(function($) {
    'use strict';

    $(document).ready(function() {
        const galleryModalEl = document.getElementById('galleryModal');
        const galleryModal = galleryModalEl ? new bootstrap.Modal(galleryModalEl) : null;
        const $modalImg = $('#galleryModalImg');

        $('.gallery-item').on('click', function() {
            const fullImage = $(this).data('full-image');
            if ($modalImg.length && fullImage) {
                $modalImg.attr('src', fullImage);
                if (galleryModal) {
                    galleryModal.show();
                }
            }
        });

        // Optional: Clear image on close
        if (galleryModalEl) {
            galleryModalEl.addEventListener('hidden.bs.modal', function() {
                $modalImg.attr('src', '');
            });
        }
    });

})(jQuery);
